export default {
  title: 'Liefersoft',
  form: {
    company_id: 'ID firmy',
    login: 'Login',
    password: 'Hasło',
  },
  buttons: {
    save: 'Zapisz',
    edit: 'Edytuj',
    cancel: 'Anuluj',
  },
  toasts: {
    error: 'Nie udało się zapisać zmian',
    success: 'Zmiany zostały zapisane',
  },
  instructions: {
    title: 'Instrukcje konfiguracji:',
    steps: {
      1: 'Przejdź do „Ustawienia" > „Ustawienia programu" > „API/Interfejsy".',
      2: 'Dodaj platformę:\n• Kliknij przycisk „Platformy".\n• Wprowadź nazwę użytkownika (np. nazwę platformy).\n• Kliknij „Zapisz".',
      3: 'Skopiuj dane API:\n• Po zapisaniu pojawi się okno z kodem platformy API.\n• Skopiuj wyświetlone dane.',
    },
  },
  connected: {
    title: 'Liefersoft jest połączony',
    description: 'Ta integracja jest skonfigurowana.',
  },
};
